import { Market, PrivacySettingToggles } from '../types/market';
import { dk as adConfig } from '../ads';

const market: Market = {
  countryCode: 'dk',
  active: true,
  sitename: 'Prisjagt',
  permanentRedirect: true,
  redirectHosts: ['m.prisjagt.dk', 'www.prisjagt.dk'],
  superSearchEndpoint: 'https://search.prisjagt.dk/rfe',
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  useClassicUrls: false,
  // If true, product tabs are accessed via e.g. #statistics rather than /statistics.
  useHashForProductTabs: true,
  classicProxy: {
    host: 'int-classic-dk.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['da'],
  sites: {
    production: 'https://prisjagt.dk',
    classic: 'https://classic.prisjagt.dk',
    analytics: 'https://prisjagt.dk/analytics/store/',
    brands: undefined,
    forum: undefined,
    mobile: undefined,
  },
  api: {
    default: 'http://int-api-dk.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'da',
  timezone: 'Europe/Copenhagen',
  currencyCode: 'DKK',
  url: {
    campaigns: '/tema',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.prisjagt.dk',
    },
  },
  socialNetworks: {
    facebook: {
      enableLogin: false,
      link: 'https://www.facebook.com/Prisjagt',
      clientID: '718724688545780',
      clientSecret: 'ba4fb261c055a469c2e98d7927a6bf9f',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
  },
  email: {
    noreply: 'noreply@prisjagt.dk',
  },
  cdn: {
    base: 'https://cdn.pji.nu',
    origin: 'http://int-cdn-origin.prisjakt.io:8080',
    images: 'https://cdn.pji.nu/images/',
  },
  routes: {
    themes: {
      path: '/tema',
    },
    campaign: {
      path: '/tema/:name',
    },
    productAlert: {
      path: '*--p:id/overvage',
      relativePath: '/overvage',
    },
    productCompare: {
      path: '/sammenlign/produkter/:productIds?',
    },
  },
  popularCampaignFilterPaths: [],

  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
  },
  featuredArticle: 1,
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey: '',
    list: '',
    gansubFormId: '',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '3',
      cookieUrl: '/info/--i7',
      privacyUrl: '/info/--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '3',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {},
};

export default market;
